import { Navigate, Route, Routes } from 'react-router-dom'

import { LoginCallback, SecurePath, SignOut } from '@lib/okta-web'
import { Utils } from '@piv/lib/rest-queries'
import { useFullscreenSpinner } from '@piv/portal/primitives/FullscreenSpinner'

import { Drilldown } from './Drilldown'
import { Inventory } from './Inventory'
import * as appRoutes from './routes'

export function App() {
  const wakeup = Utils.useWakeupCall()

  // TODO: what about the less happy path?
  useFullscreenSpinner(wakeup.isFetching)

  return (
    <Routes>
      <Route path="/" element={<Navigate to={appRoutes.Explore.Home} />} />

      <Route path="/" element={<SecurePath />}>
        <Route path={appRoutes.Explore.Home} element={<Inventory />} />
        <Route path={appRoutes.Explore.Detail} element={<Inventory />} />
        <Route path={appRoutes.Explore.Drilldown} element={<Drilldown />} />
      </Route>

      <Route path={appRoutes.Auth.SignInResponse} element={<LoginCallback />} />

      <Route path={appRoutes.Auth.SignOut} element={<SignOut />} />

      <Route element={<div>Unknown</div>} />
    </Routes>
  )
}

export default App
